import React from 'react';
import CommentInput from './input';

const config = {
  // List Table
  init: {
    obfuscated_text: '',
    hidden: false
  },
  list: {
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the comment ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'id',
      order: 'descend'
    },
    filters: {},
    // General
    title: 'Comments'
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Comment',
    title: 'Comment',
    component: props => (
      <CommentInput
        {...props}
        title="Comment"
        themeName="action"
      />
    )
  }
};

export default config;
